import React, { useEffect, useState } from 'react'
import { Page, View, Document as Doc, StyleSheet, PDFViewer } from '@react-pdf/renderer'
import { ParametroType } from '../../Types/ParametroType'
import TableHeader from './Table/header'
import TableRow from './Table/row'
import TableBanner from './Table/banner'

const ParametroPdf: React.FC = () => {

    const [parametro, setParametro] = useState<ParametroType[] | null>(null)

    const styles = StyleSheet.create({
        page: {
            flexDirection: 'row',
            backgroundColor: '#FFFFFF'
        },
        section: {
            margin: 10,
            padding: 10,
            flexGrow: 1
        }
    })

    useEffect(() => {
        (async() => { setParametro(JSON.parse(localStorage.getItem('Parametro')!)) })()
    }, [])

    return(

        <>
            {!!parametro && (
                <PDFViewer style={{ width: '100vw', height: '100vh' }}>
                    <Doc>
                        <Page size="A4" style={styles.page} break>
                            <View style={styles.section}>
                                <TableBanner />
                                <TableHeader />
                                {parametro.map((item, index) => <TableRow key = {index} {...item} />)}
                            </View>
                        </Page>
                    </Doc>
                </PDFViewer>
            )}
        </>

    )

}

export default ParametroPdf